<div class="footer-second text-center footer-fix font-size-15 p-t-60 page_wrapper mt-5">
  <div class="text-center font-size-17 font-weight-400 text-change mb-5">Facing issue or need support?
    <span class="text-color font-size-17 font-weight-500 cursor-pointer"> CALL (44) 495 060 77</span>
  </div>
  <div class="container-fluid card pl-lg-5 pr-lg-5 pl-3 pr-3">
    <div class="row text-justify mt-5 pt-4">
      <!-- <div class="col-xl-1 "></div> -->
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
        <!-- footer-widget -->
        <div class="footer-second-widget mr-4 ml-3">
          <div class="">
            <a href="{{homePageUrl}}" class="link-hover">
              <img src="/assets/images/logo1.svg" alt="" class="wh-300px">
            </a>
          </div>
          <p class="text-change font-size-15 line-height text-change mt-2">We are your one-stop place to look for health
            care
            advisors
            online.
            We bring in years of medical consulting
            experience and technology together to provide a secure safe platform
            for common people with no technical skills to get quality health consultation with no strings attached.

          </p>
        </div>
      </div>
      <!-- /.footer-widget -->
      <!-- footer-widget -->
      <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6">
        <div class="footer-second-widget">
          <h3 class="footer-second-widget-title mb-4 mt-3 font-size-16 text-change">
            ABOUT US
          </h3>
          <ul class="list-unstyled">
            <li><a href="{{aboutUsUrl}}" class="link-hover">About us</a></li>
            <li><a href="{{ourTeamUrl}}" class="link-hover">Our Team</a></li>
            <li><a href="{{contactUsUrl}}" class="link-hover">Contact Us</a></li>
            <li><a href="{{blogUrl}}" class="link-hover">Our Blog</a></li>
          </ul>
        </div>
      </div>
      <!-- /.footer-widget -->
      <!-- footer-widget -->
      <div class="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-6">
        <div class="footer-second-widget ">
          <h3 class="footer-second-widget-title mb-4 mt-3 font-size-16 text-change">
            QUICK LINKS
          </h3>
          <ul class="list-unstyled link-hover">
            <li><a href="index-6.html#" class="link-hover" routerLink="/login" routerLinkActive="active">Login Your
                Account</a></li>
            <li><a href="index-6.html#" class="link-hover" routerLink="/register" routerLinkActive="active">Create New
                Account</a></li>
            <li><a href="index-6.html#" class="link-hover" routerLink="/physician/search"
                routerLinkActive="active">Search Doctor</a></li>
            <li><a href="index-6.html#" class="link-hover" routerLink="/search/appointment"
                routerLinkActive="active">Search
                Appointment</a></li>
          </ul>
        </div>
      </div>
      <!-- /.footer-widget -->
      <!-- /.footer-widget -->
      <div class="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-8">
        <div class="footer-second-widget">
          <h3 class="footer-second-widget-title mb-4 mt-3 font-size-16 text-change">
            HELPDESK
          </h3>
          <ul class="list-unstyled link-hover">
            <li><a href="tel: +91-984-039-9184" class="link-hover">(44) 495 060 77</a></li>
            <li><a href="mailto:support@reliabledrs.com" class="link-hover">support@reliabledrs.com</a></li>
            <li><a href="{{privacyPolicyUrl}}" class="link-hover">Privacy Policy</a></li>
            <li><a href="{{termsUrl}}" class="link-hover">Terms & Conditions</a></li>

          </ul>
        </div>
      </div>
      <!-- /.footer-widget -->
    </div>
  </div>
</div>
<!-- //Tiny footer -->
<div class="tiny-footer page_wrapper">
  <div class=" container-fluid card pl-lg-5 pr-lg-5 pl-3 pr-3">
    <div class="row">
      <div class="col-xl-6 col-lg-4 col-md-12 col-sm-12 col-12 ">
        <ul class="list-unstyled d-flex">
          <li><a href="#"><i class="fa fa-facebook text-dark font-size-16 ml-3 mr-3 mt-3"></i></a></li>
          <li><a href="#"><i class="fa fa-instagram text-dark font-size-16 mr-3 mt-3"></i></a></li>
          <li><a href="#"><i class="fa fa-twitter text-dark font-size-16 mt-3"></i></a></li>
        </ul>
      </div>
      <div class="col-xl-6 col-lg-8 col-md-12 col-sm-12 col-12 text-right">
        <p class="mt-3 float-md-right d-flex">Copyright © 2021 ReliableDRS.</p>
      </div>
    </div>
  </div>
</div>